import PropTypes from "prop-types";
import React from "react";

import { connect } from "react-redux";
import { Container, Dropdown } from "reactstrap";

import { Link } from "react-router-dom";
// Import menuDropdown
import logoSm from "../../../assets/images/logo-sm.png";
import logoDark from "../../../assets/images/logo-dark.png";
import logoLightXSm from "../../../assets/images/logo-sm-dark.png";
import logoDarkXSm from "../../../assets/images/logo-sm-dark.png";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../../store/actions";

const Header = (props) => {
  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 768) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar" className="page-hdr-top" style={(window.location.pathname === "/detail" || window.location.pathname === "/recruiter/detail") ? { left: 0 } : {}}>
        <div className="navbar-header">
          <Container fluid>
            <div className="float-end">
              {/* <LanguageDropdown />{" "} */}
              <Dropdown className="d-none d-lg-inline-block ms-1"></Dropdown>
              {/* <NotificationDropdown /> */}
            </div>
            <div>
              <div className="navbar-brand-box" style={{ width: "auto", paddingLeft: "20px" }}>
                <Link to="/" className="logo">
                  <span className="logo-lg">
                    <img src={require("../../../assets/images/logo.png")} alt="HireNeuron" height="70" style={{ paddingTop: "10px" }} />
                  </span>
                </Link>
              </div>
              <button
                type="button"
                className="btn btn-sm px-2 font-size-16 d-lg-none header-item waves-effect waves-light"
                data-toggle="collapse"
                onClick={() => {
                  tToggle();
                }}
                data-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars"></i>
              </button>
            </div>
          </Container>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = null;

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
